import type { HTMXEvent } from '@/events/types';

import { loadingHandler as commonLoadingHandler } from '../../common_handlers/loading';

const loadingHandler = (event: HTMXEvent) => {
    commonLoadingHandler(event.detail.target.dataset, false);
};

export { loadingHandler };
